import { render, staticRenderFns } from "./HeroSmall.vue?vue&type=template&id=14fca42c&"
import script from "./HeroSmall.vue?vue&type=script&lang=js&"
export * from "./HeroSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports